import { useLayoutEffect } from "react";

const PANEL_MAX_HEIGHT = 760;

const PANEL_MIN_HEIGHT = 240;

const PANEL_BOTTOM_GAP = 16;

const PANEL_MAX_HEIGHT_VARIABLE = "--workshop-panel-max-height";

const usePanelMaxHeight = (panelRef) => {
  useLayoutEffect(() => {
    const measure = () => {
      const panel = panelRef.current;
      if (!panel) return;
      const { top } = panel.getBoundingClientRect();
      const height = Math.max(
        PANEL_MIN_HEIGHT,
        Math.min(PANEL_MAX_HEIGHT, window.innerHeight - top - PANEL_BOTTOM_GAP),
      );
      panel.style.setProperty(PANEL_MAX_HEIGHT_VARIABLE, `${height}px`);
    };
    let frame = null;
    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        measure();
      });
    };
    measure();
    window.addEventListener("resize", measure);
    window.addEventListener("scroll", onScroll, true);
    return () => {
      window.removeEventListener("resize", measure);
      window.removeEventListener("scroll", onScroll, true);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [panelRef]);
};

export default usePanelMaxHeight;
